import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { CSRF_HEADERS } from 'globals/constants'
import { API_POST_URL, DEFAULT_RESPONSE_ERROR, GA_EVENT_CATEGORY } from './constants'

export const SET_LEAD_DETAILS = 'SET_LEAD_DETAILS'
export const IS_LOADING = 'IS_LOADING'
export const IS_SUCCESS = 'IS_SUCCESS'
export const SUBMIT_LEAD = 'SUBMIT_LEAD'
export const SET_RESPONSE_MESSAGE = 'SET_RESPONSE_MESSAGE'
export const SET_FIELD_ERRORS = 'SET_FIELD_ERRORS'
export const CLEAR_FIELD_ERROR = 'CLEAR_FIELD_ERROR'
export const SET_MANUAL_ADDRESS = 'SET_MANUAL_ADDRESS'
export const REDIRECT_PAGE = 'REDIRECT_PAGE'

export function setLeadDetails(fields) {
  return { type: SET_LEAD_DETAILS, payload: fields }
}

export function isLoading(status) {
  return { type: IS_LOADING, payload: status }
}

export function setResponseMessage(status) {
  return { type: SET_RESPONSE_MESSAGE, payload: status }
}

export function setFieldErrors(errors) {
  Object.keys(errors).forEach((field) => {
    gaEvent('Failed', {
      event_category: GA_EVENT_CATEGORY,
      event_label: 'Invalid',
      field_name: field,
      error_message: errors[field],
      non_interaction: true,
    })
  })
  return { type: SET_FIELD_ERRORS, payload: errors }
}

export function clearFieldError(fieldName) {
  return { type: CLEAR_FIELD_ERROR, payload: fieldName }
}

function isSuccess(status) {
  return { type: IS_SUCCESS, payload: status }
}

export function setManualAddress(state) {
  return { type: SET_MANUAL_ADDRESS, payload: state }
}

function redirectPage(targetUrl) {
  return { type: REDIRECT_PAGE, payload: targetUrl }
}

function postToLeadAPI(leadData, manualAddress, successRedirect) {
  return (dispatch) => {
    const options = { headers: { ...CSRF_HEADERS } }

    const payload = {
      ...leadData,
      is_manual_address: manualAddress,
      proceed_to_checkout: !!successRedirect,
    }

    axios
      .post(API_POST_URL, payload, options)
      .then((response) => {
        if (response.data.success) {
          gaEvent('Success', {
            event_category: GA_EVENT_CATEGORY,
            event_label: manualAddress ? 'Address (Manual)' : 'Address (Autocomplete)',
            non_interaction: true,
          })
          if (successRedirect) {
            dispatch(redirectPage(successRedirect))
          } else {
            dispatch(isSuccess(true))
            dispatch(isLoading(false))
          }
        } else {
          dispatch(setResponseMessage(DEFAULT_RESPONSE_ERROR))
          gaEvent('Failed', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Rejected',
            non_interaction: true,
          })
        }
      })
      .catch((error) => {
        dispatch(isLoading(false))
        dispatch(setResponseMessage(DEFAULT_RESPONSE_ERROR))
        if (!error.response) {
          // network error
          gaEvent('Failed', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Network Error',
            non_interaction: true,
          })
        } else if (error.response.data && error.response.data.errors) {
          // response data
          const response = error.response.data
          dispatch(setFieldErrors(response.errors))
        } else {
          // Error HTML page from CDN, Heroku or Django
          gaEvent('Failed', {
            event_category: GA_EVENT_CATEGORY,
            event_label: error.response.statusText,
            non_interaction: true,
          })
        }
      })
  }
}

export function submitLead(leadData, manualAddress, successRedirect) {
  return (dispatch) => {
    dispatch(isLoading(true))
    dispatch(setLeadDetails(leadData))
    dispatch(postToLeadAPI(leadData, manualAddress, successRedirect))
  }
}



// WEBPACK FOOTER //
// ./containers/LeadGen/actions.js